import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Label } from 'reactstrap';
import { DatePicker } from 'antd';
import moment from 'moment';

// Import helpers
import { REQUIRED_MARK } from 'components/helpers/variables';

const DatePickerLabel = ({
	input,
	id,
	label,
	placeholder = '',
	labelColumn = 2,
	inputColumn = 10,
	showTime = false,
	format = 'YYYY-MM-DD',
	meta: { touched, error, submitError },
	requiredField = false,
	...inputProps
}) => {
	return (
		<FormGroup row className={`${touched && error ? 'has-error' : ''} `}>
			<Label
				for={id}
				sm={labelColumn}
				className="col-form-label col-form-label-lg"
			>
				{label} {requiredField && REQUIRED_MARK}
			</Label>
			<Col sm={inputColumn}>
				<DatePicker
					{...input}
					{...inputProps}
					value={input.value ? moment(input.value) : null}
					id={id}
					placeholder={placeholder}
					showTime={showTime}
					format={showTime ? 'YYYY-MM-DD HH:mm:ss' : format}
				/>
				{touched && (error || submitError) && (
					<div>
						<span
							data-testid={`input-error-${input.name}`}
							className="input-error d-block"
						>
							{error || submitError}
						</span>
					</div>
				)}
			</Col>
		</FormGroup>
	);
};

DatePickerLabel.propTypes = {
	input: PropTypes.object.isRequired,
	label: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	labelColumn: PropTypes.number,
	inputColumn: PropTypes.number,
	showTime: PropTypes.bool,
	format: PropTypes.string,
	meta: PropTypes.object,
	requiredField: PropTypes.bool
};

export default DatePickerLabel;
